import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { StudentService } from 'src/app/private/services/student.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-student-profile',
  imports: [SharedModule],
  templateUrl: './create-student-profile.component.html',
  styleUrl: './create-student-profile.component.scss'
})
export class CreateStudentProfileComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private studentService: StudentService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleGenerateProfile() {
    // Check if student_profile_credentials exists before making API call
    const studentProfileCredentials = this.localStorage.getModuleMapping('student_profile_credentials');
    
    if (!studentProfileCredentials) {
      this.handleCloseDialog();
      this.confirmationService.confirm({
        key: 'emailConfigSteps',
        header: 'Email Configuration Required',
        message: 'Please connect your domain and assign a dedicated email address to send student profile credentials.',
        acceptLabel: 'Connect Now',
        rejectLabel: 'Cancel',
        rejectVisible: true,
        accept: () => {
          this.router.navigate(['/main/settings/configuration-panel']);
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId(),
      lead_id: this.editLeadData?.lead_id,
      user_id: this.localStorage.getUserId(),
      reg_id: this.editLeadData?.registration?.reg_id,
      application_id: this.editLeadData?.application_data?.application_id,
      enrollment_id: this.editLeadData?.enrollment_data?.enrollment_id,
      admission_id: this.editLeadData?.admission_id
    }

    this.isLoading = true;

    this.studentService.createStudentTempProfile(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.handleCloseDialog();
        
        if (res?.message === 'Email configuration not found') {
          this.confirmationService.confirm({
            key: 'emailConfigSteps',
            header: 'Email Configuration Required',
            message: 'Please connect your domain and assign a dedicated email address to send student profile credentials.',
            acceptLabel: 'Connect Now',
            rejectLabel: 'Cancel',
            rejectVisible: true,
            accept: () => {
              this.router.navigate(['/main/settings/configuration-panel']);
            },
            reject: () => {
              this.confirmationService.close();
            }
          });
        } else {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Student profile created successfully' });
          this.reload.emit();
          this.handleCloseDialog();
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Error creating student profile' });
      }
    });
  }

}
